<div class="flex flex-end align-bottom items-center md:h-9">
  <app-item-image class="cursor-pointer item-image" [item]="item()" [width]="imageSize()" [height]="imageSize()" (click)="openModal.emit()" title="Show item details"/>

  <div class="h-14">
    <div class="h-1/3">
      @if(item().programs?.length) {
        <div #programIconContainer title="Programs">
          <app-link><app-icons icon="certificate"/></app-link>
        </div>

        <app-tooltip [triggerEl]="programIconContainer" placement="right" triggerType="click">
          <h5 class="text-lg font-bold dark:text-white">Programs</h5>
          <ul class="pl-4 list-disc">
            @for (program of item().programs; track $index) {
              <li>
                {{program.name}}
              </li>
            }
          </ul>

        </app-tooltip>
      }

    </div>
    <div class="h-1/3">
      @if(item().rebates?.length && access.has('view_rebates')) {
        <div #rebateIconContainer class="item-rebate">
          <app-link [disabled]="access.cannot('view_rebates')" [title]="access.getTitle('view_rebates', 'View Rebates')">
            <app-icons icon="tag"/>
          </app-link>
        </div>

        @if (access.can('view_rebates')) {
          <app-tooltip [triggerEl]="rebateIconContainer" placement="right" triggerType="click">
            <h5 class="text-lg font-bold dark:text-white">Rebates</h5>

            <ul class="pl-4 list-disc">
              @for (rebate of item().rebates; track $index) {
                <li>
                  {{rebate.name}} <app-link><a [href]="rebate.url" target="_blank"><app-icons icon="arrow-up-right-from-square"/></a></app-link>
                </li>
              }
            </ul>
          </app-tooltip>
        }
      }
    </div>

    <div class="h-1/3">
      @if(item().spiff && access.has('view_spiff_codes') && access.can('view_spiff_codes')) {
        <div #spiffIconContainer title="Spiffs" class="item-spiff">
          <app-link>
            <app-icons icon="sack-dollar"/>
          </app-link>
        </div>

        <app-tooltip [triggerEl]="spiffIconContainer" placement="right" triggerType="click">
          Spiff
          <br>
          {{item().spiff.name}} {{item().spiff.amount | currency}}
        </app-tooltip>
      }
    </div>
  </div>

</div>
